import { render } from "./settingPage.vue?vue&type=template&id=2ae27826"
import script from "./settingPage.vue?vue&type=script&lang=js"
export * from "./settingPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__